/* NORA PRO: open the desktop mega menu on hover (Dawn opens on click by default). */
(function () {
  var DESKTOP = 990;
  var openTimers = new WeakMap();

  function bind() {
    var menus = document.querySelectorAll('.header__inline-menu details.mega-menu');
    menus.forEach(function (details) {
      if (details.dataset.noraHover) return;
      details.dataset.noraHover = '1';

      details.addEventListener('mouseenter', function () {
        if (window.innerWidth < DESKTOP) return;
        clearTimeout(openTimers.get(details));
        // close any siblings that are open
        menus.forEach(function (d) { if (d !== details) d.removeAttribute('open'); });
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', function () {
        if (window.innerWidth < DESKTOP) return;
        var t = setTimeout(function () { details.removeAttribute('open'); }, 120);
        openTimers.set(details, t);
      });
    });
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
